export const inputCls =
  "w-full border border-[#132C44]/20 rounded-lg px-3 py-2 text-[13px] bg-white focus:outline-none focus:ring-2 focus:ring-[#8AA986]/50";
export const btnPrimary =
  "rounded-lg bg-[#132C44] text-[#F6EFDF] px-4 py-2 text-[12px] font-semibold hover:bg-[#1E3A5F] transition-colors disabled:opacity-50";
export const btnSage =
  "rounded-lg bg-[#8AA986] text-[#132C44] px-4 py-2 text-[12px] font-semibold hover:bg-[#7a9a76] transition-colors disabled:opacity-50";
export const btnGhost =
  "rounded-full border border-[#132C44]/30 px-3 py-1.5 text-[12px] font-semibold hover:bg-[#132C44] hover:text-[#F6EFDF] transition-colors";
export const btnDanger =
  "rounded-full border border-[#9B2C3B]/40 text-[#9B2C3B] px-3 py-1.5 text-[12px] font-semibold hover:bg-[#9B2C3B] hover:text-[#F6EFDF] transition-colors";
export const panel = "p-4 sm:p-5 bg-white rounded-2xl border border-[#132C44]/10";

export const activationUrl = (token) => `${window.location.origin}/english-id/activate/${token}`;
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("es-UY") : "—");
